// utils/tag-appearance.ts
export type TagAppearance =
  | {
      kind: 'status';
      status: 'pending' | 'transition' | 'todo' | 'error' | 'to-correct' | 'completed';
      declination?: 'primary' | 'secondary';
    }
  | {
      kind: 'brand';
      brand: 'prodemial' | 'my-stellium' | 'financement' | 'placement' | 'immobilier';
      declination?: 'primary' | 'secondary';
    };

const AGE_TAG_CODES = new Set(['MINEUR', '75_79', '80_84', '85_89', '90_94', '95_PLUS']);
const PPE_GDA_TAG_CODES = new Set(['PPE', 'GDA']);

export function getTagAppearance(tag: { code: string; isPermanent: boolean }) {
  if (AGE_TAG_CODES.has(tag.code)) {
    return { kind: 'brand', brand: 'placement' as const, declination: 'primary' as const };
  }

  if (PPE_GDA_TAG_CODES.has(tag.code)) {
    return { kind: 'status', status: 'error' as const, declination: 'secondary' as const };
  }

  if (tag.isPermanent) {
    return { kind: 'brand', brand: 'placement' as const, declination: 'secondary' as const };
  }

  return { kind: 'status', status: 'pending' as const, declination: 'primary' as const };
}
